import { normalizeOverlayPath } from "@/lib/global-overlays";

export type MobileNavKey = "kundali" | "panchang" | "remedies";

const NAV_MATCHERS: Record<MobileNavKey, readonly string[]> = {
  kundali: ["/free-kundali", "/kundali"],
  panchang: ["/panchang", "/my-panchang"],
  remedies: ["/upay"],
};

function withoutLocale(pathname: string): string {
  return pathname === "/hi" ? "/" : pathname.replace(/^\/hi(?=\/)/, "");
}

export function isHindiMobileJourney(pathname: string): boolean {
  const path = normalizeOverlayPath(pathname);
  return path === "/hi" || path.startsWith("/hi/");
}

export function isMobileNavItemActive(pathname: string, key: MobileNavKey): boolean {
  const path = withoutLocale(normalizeOverlayPath(pathname));
  return NAV_MATCHERS[key].some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function mobileNavKeyForPath(pathname: string): MobileNavKey | null {
  return (
    (Object.keys(NAV_MATCHERS) as MobileNavKey[]).find((key) =>
      isMobileNavItemActive(pathname, key)
    ) ?? null
  );
}
